import React from 'react';
import { useMsal } from '@azure/msal-react';
import request from 'utils/http';
import { useHistory } from 'react-router-dom';

import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const useAuthorize = () => {
    const { instance, accounts: allAccounts } = useMsal();
    const history = useHistory();

    const isAuthorized = window.localStorage.getItem('token') !== null;

    React.useEffect(() => {
        if (process.env.AZURE_SSO_LOGIN_ENABLED === 'true') {
            if (allAccounts.length === 0 && window.localStorage.getItem('token') === null
                && _get(history, 'location.pathname', null) !== '/account/login'
            ) {
                request.redirectTo('/account/login');
                return;
            }
            if (window.localStorage.getItem('token') === null && _get(history, 'location.pathname', null) !== '/account/login') {
                request.redirectTo('/account/login');
                return;
            }
        } else {
            if (_isEmpty(localStorage.getItem('token')) && _get(history, 'location.pathname', null) !== '/account/login') {
                request.redirectTo('/account/login');
            }
        }
    }, [instance]);
    return { allAccounts, isAuthorized };
};

export default useAuthorize;